import React from 'react';
import { Reveal } from '../ui/Reveal';
const BLOQUES = [{
  emoji: '🏛',
  titulo: 'Meditación Profunda',
  texto: 'En templos ancestrales y villas privadas con vistas a la selva. Sin presiones, sin expectativas — solo tú y tu proceso de liberación hacia el gozo y la plenitud.'
}, {
  emoji: '🌿',
  titulo: 'Tu Ritmo Sagrado',
  texto: 'Guías expertas que respetan cada paso de tu proceso. Aquí no hay prisa. Hay amor, presencia y el espacio para que se teja lo que eres.'
}];
export function Presencia() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-152">
      <div className="mx-auto max-w-5xl text-center" data-id="element-153">
        <Reveal data-id="element-154">
          <span className="text-xs font-medium uppercase tracking-[0.28em]" style={{
          color: 'var(--satinsheengold)'
        }} data-id="element-155">
            Presencia Total
          </span>
          <h2 className="mt-4 font-heading text-3xl font-light leading-tight sm:text-4xl" style={{
          color: 'var(--ink)'
        }} data-id="element-156">
            Espacios de Silencio y Acompañamiento Amoroso
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-157">
          {BLOQUES.map((b, i) => <Reveal key={b.titulo} delay={i * 0.1} data-id="element-158">
              <article className="h-full rounded-3xl border p-8 text-left" style={{
            borderColor: 'rgba(24,161,184,0.2)',
            backgroundColor: 'rgba(24,161,184,0.05)'
          }} data-id="element-159">
                <span className="text-4xl" data-id="element-160">{b.emoji}</span>
                <h3 className="mt-4 font-heading text-xl font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-161">
                  {b.titulo}
                </h3>
                <p className="mt-3 text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-162">
                  {b.texto}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}